// extracted by mini-css-extract-plugin
export default {"userSettingsPage":"UserSettingsPage_userSettingsPage__Uw4hi"};